import { createFileRoute, Link } from '@tanstack/react-router'
import { Button } from '@journ/ui/button'
import { useIntlayer } from 'react-intlayer'

export const Route = createFileRoute('/not-found')({
	component: NotFoundPage,
})

function NotFoundPage() {
	const content = useIntlayer('not-found')
	return (
		<div className='min-h-screen flex items-center justify-center'>
			<div className='max-w-md w-full text-center px-4'>
				<p className='text-878787 text-sm mb-2'>{content.code}</p>
				<h2 className='font-medium mb-4'>{content.title}</h2>
				<p className='text-sm text-878787 mb-8'>{content.description}</p>
				<Button asChild variant='outline'>
					<Link to='/'>{content.goHome}</Link>
				</Button>
			</div>
		</div>
	)
}
